import React from 'react';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage } from './wsHelpers';
import { connect } from 'react-redux';
import { deleteConnection } from '@/redux/actions';

const WS_CONNECTIONS_BY_HTTP = {
	CREATE_CONNECTION: `connections/POST`,
	UPDATE_CONNECTION: `connections/:connectionID/PATCH`,
	DELETE_CONNECTION: `connections/:connectionID/DELETE`,
};

const AttendeeConnectionsSubscriptions = props => {
	const {
		socket,
		children,
		currentEventId,
		connections,
		// createConnection,
		deleteConnection,
	} = props;

	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribeToConnections = () => {
		socket.emit('event/:eventID/connections/SUBSCRIBE', { eventID: currentEventId, connections });
		console.log('⚡️ AttendeeConnectionsSubscriptions Mounted ⚡️', connections);
	};

	const unsubscribeToConnections = () => {
		socket.emit('event/:eventID/connections/UNSUBSCRIBE', { eventID: currentEventId, connections });
		console.log(`🚶‍♂️ AttendeeConnectionsSubscriptions Unmounted 🚶‍♂️`, connections);
	};

	// const listenForCreatedConnection = () => {
	// 	console.log(WS_CONNECTIONS_BY_HTTP.CREATE_CONNECTION, 'running');
	// 	socket.on(WS_CONNECTIONS_BY_HTTP.CREATE_CONNECTION, payload => {
	// 		const { data, error } = payload;
	// 		if (error) displayMessage(`connection could not be created`, error);
	// 		else {
	// 			const { name } = data;
	// 			// createConnection(data);
	// 			displayMessage(`${name} created`);
	// 		}
	// 	});
	// };

	const listenForDeletedConnection = () => {
		socket.on(WS_CONNECTIONS_BY_HTTP.DELETE_CONNECTION, payload => {
			const { data, error } = payload;
			if (error) displayMessage(`connection could not be deleted`, error);
			else {
				deleteConnection(data.connectionID);
				displayMessage(`Connection succesfully deleted`);
			}
		});
	};

	const listeners = () => [
		// listenForCreatedConnection,
		listenForDeletedConnection,
	];

	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribeToConnections}
				unsub={unsubscribeToConnections}
				listeners={listeners()}
				routes={Object.values(WS_CONNECTIONS_BY_HTTP)}
			/>
			{React.cloneElement(children, propsToSend)}
		</>
	);
};

const msp = ({ ws, auth, events }) => ({
	socket: ws.socket,
	auth0Token: auth.auth0Token,
	currentEventId: events.currentEvent.id,
});

const mdp = dispatch => ({
	// createConnection: (connection, from) => dispatch(createConnection(connection, from)),
	deleteConnection: (connectionID, from) => dispatch(deleteConnection(connectionID, from)),
});

export default connect(msp, mdp)(AttendeeConnectionsSubscriptions);
